import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Modal, OutlinedInput, Select, Slider, Theme, Typography, capitalize, styled, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { Value } from 'sass';
import { WineFilters } from './WineList';
import { WineType } from '../../models/wine';
import { DeepCopy, DeepCopyArray } from '../../Helper';

export interface WineFilterModalProps {
    open: boolean;
    onClose?: any;
    allWineCharacteristics: string[];
    wineFiltersAccessor: any;


}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function valuetext(value: number) {
    return `${value}%`;
}


function WineFilterModal(props: WineFilterModalProps) {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const [wineFilters, setWineFilters] = props.wineFiltersAccessor;
    const theme = useTheme();



    const applyFilters = () => props.onClose();
    const cancel = () => {
        setWineFilters({ types: [], charactestics: [] });
        props.onClose();
    }

    const setCharacteristics = (e: any) => {
        setWineFilters((wf: WineFilters) => { wf.charactestics = e.target.value; return DeepCopy(wf) });
    }

    const setTypes = (e: any) => {
        setWineFilters((wf: WineFilters) => { wf.types = e.target.value; return DeepCopy(wf) });
        // console.log(e.target.value[0] == WineType.Bollicine);
    }

    function getStyles(name: string, personName: string[], theme: Theme) {
        return {
            fontWeight:
                personName.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    }

    return (
        <BootstrapDialog
            onClose={props.onClose}
            aria-labelledby="customized-dialog-title"
            open={props.open}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Ti aiutiamo a scegliere
            </DialogTitle>
            {/* <IconButton
                aria-label="close"
                onClick={props.onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton> */}
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={8}>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <InputLabel id="demo-multiple-name-label">I Step</InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                multiple
                                value={wineFilters.types}
                                onChange={setTypes}
                                input={<OutlinedInput label="Name" />}
                                MenuProps={MenuProps}
                            >
                                {Object.values(WineType).filter(_ => typeof(_)== 'string').map((type) => (
                                    <MenuItem
                                        key={type.toString()}
                                        value={type.toString()}
                                        // style={getStyles(type.toString(), Object.keys(WineType), theme)}
                                    >
                                        {type}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={8}>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <InputLabel id="demo-multiple-name-label">II Step</InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                multiple
                                value={wineFilters.charactestics}
                                onChange={setCharacteristics}
                                input={<OutlinedInput label="Name" />}
                                MenuProps={MenuProps}
                            >
                                {props.allWineCharacteristics.map((name) => (
                                    <MenuItem
                                        key={name}
                                        value={name}
                                        style={getStyles(name, props.allWineCharacteristics, theme)}
                                    >
                                        {capitalize(name)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions className='flex-between'>
                <Button onClick={cancel}>
                    Rimuovi Tutti i Filtri
                </Button>
                <Button onClick={applyFilters}>
                    Applica
                </Button>
            </DialogActions>
        </BootstrapDialog>
    );
}

export default WineFilterModal;